export default __webpack_public_path__ + "static/media/lemonGrassFacebook-639x418.bc7223f2.jpg";